import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M8.94 78.88c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M63.57 8.3a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path fill="#D8FFFF" d="M58 87.94a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#00D8D8"
      d="m42.51 102.8 3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM53.74 31.75h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57H39.6c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M62.39 41.46l10.39 10.39-43.01 43.01c-2.41 2.41-6.32 2.41-8.72 0l-1.67-1.67c-2.41-2.41-2.41-6.32 0-8.72z"
    />
    <path
      fill="#0597A3"
      d="M97.46 42.65c-.23-.22-.53-.35-.84-.38l-5.9-.54a1.42 1.42 0 0 1-1.29-1.5l.31-5.36c.02-.38-.11-.75-.36-1.04-2.09-2.31-11.86-12.91-16.8-15.21-8.24-3.83-19.22-5.34-24.54-5.08-.82.04-1.43.75-1.35 1.57.08.74.71 1.3 1.45 1.28 3.17-.08 11.21.33 14.57 6.04 3.56 6.06.86 15.38-.08 18.18-.17.51-.04 1.08.35 1.46l9.37 9.33c.28.28.67.43 1.07.41l5.29-.25c.81-.04 1.49.61 1.49 1.42v4.81c0 .39.16.76.44 1.03l16.84-16.16z"
    />
    <path
      fill="#D8FFFF"
      d="m102.4 47.26-4.93-4.6-16.84 16.16 5.58 5.36c.57.54 1.47.53 2.01-.04l14.23-14.85c.55-.57.52-1.49-.06-2.03z"
    />
  </svg>
);
const SvgEnrichedIconSubsBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconSubsBrand);
export default Memo;
